import React from 'react';
import { Box, HStack } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/icons';
import { keyframes } from '@emotion/react';

// Pulse animation for play button
const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

// Define the keyframes for the beat animation
const beatAnimation = keyframes`
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(2); }
`;

// Define an AnimatedBeatBar component to apply the animation
const AnimatedBeatBar = ({ delay, ...props }) => (
  <Box
    as="div"
    bg="currentColor"
    height="5px"
    width="1px"
    animation={`${beatAnimation} 1s infinite ease-in-out`}
    style={{ animationDelay: `${delay}s` }}
    transformOrigin="bottom"
    {...props}
  />
);

// Music beat icon using HStack with animated bars
const BeatIcon = ({ ...props }) => (
  <HStack spacing="2px" {...props}>
    <AnimatedBeatBar delay={0} />
    <AnimatedBeatBar delay={0.1} />
    <AnimatedBeatBar delay={0.2} />
    <AnimatedBeatBar delay={0.3} />
    <AnimatedBeatBar delay={0.4} />
  </HStack>
);




const bounce = keyframes`
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(2); }
`;

const AnimatedBars = () => {
    return (
        <HStack spacing="2px">
            {[...Array(3)].map((_, i) => (
                <Box
                    key={i}
                    bg="currentcolor"
                    width="3px"
                    height="10px"
                    animation={`${bounce} 0.5s ease-in-out infinite`}
                    animationDelay={`${i * 0.1}s`}
                />
            ))}
        </HStack>
    );
};

const AnimatedPlayIcon = ({ ...props }) => (
  <Icon 
    viewBox="0 0 24 24" 
    {...props}
    animation={`${pulseAnimation} 1s infinite`}
  >
    <path d="M8 5v14l11-7z" />
  </Icon>
);

const AnimatedPauseIcon = ({ ...props }) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M6 19h4V5H6zm8-14v14h4V5h-4z" />
  </Icon>
);

// Music beat icon with animation
// const BeatIcon = ({ ...props }) => (
//   <Icon viewBox="0 0 100 100" {...props}>
//     <g fill="currentColor">
//       <rect x="10" y="40" width="10" height="20" transform="scaleY(1)" animation={`${beatAnimation} 0.5s infinite`} />
//       <rect x="30" y="30" width="10" height="40" transform="scaleY(1)" animation={`${beatAnimation} 0.6s infinite`} />
//       <rect x="50" y="20" width="10" height="60" transform="scaleY(1)" animation={`${beatAnimation} 0.7s infinite`} />
//       <rect x="70" y="30" width="10" height="40" transform="scaleY(1)" animation={`${beatAnimation} 0.6s infinite`} />
//       <rect x="90" y="40" width="10" height="20" transform="scaleY(1)" animation={`${beatAnimation} 0.5s infinite`} />
//     </g>
//   </Icon>
// );

export { AnimatedPlayIcon, AnimatedPauseIcon, BeatIcon , AnimatedBars};
